import {mountCartDiscount,checkoutWithDiscount} from './pevita-studio--cart-discount.js?v=magsafe-live20261029a';
mountCartDiscount();
import {initMarketSuggestion} from './pevita-studio--market-localization.js?v=clarity-fixes-20261030';
import {initI18n,localisePolicyLinks,getLanguage,localizedUrl} from './pevita-studio--i18n.js?v=clarity-fixes-20261030';
initI18n();
initMarketSuggestion();
const request=(...args)=>import('./pevita-studio--commerce.js?v=clarity-fixes-20261030').then(module=>module.request(...args));
import {business} from './pevita-studio--business.js?v=magsafe-live20261029a';
import {mountDelivery} from './pevita-studio--delivery-ui.js?v=magsafe-live20261029a';
const menu=document.getElementById('menu-toggle'),nav=document.getElementById('store-nav');
document.querySelector('.skip-link')?.addEventListener('click',event=>{const main=document.getElementById('main-content');if(main){event.preventDefault();main.tabIndex=-1;main.focus();main.scrollIntoView({block:'start'});}});
// The editor owns its own menu; standalone Shopify pages use this lightweight shell.
if(menu&&nav&&!document.getElementById('editor-screen')){
  menu.onclick=()=>{const open=menu.getAttribute('aria-expanded')!=='true';menu.setAttribute('aria-expanded',String(open));nav.classList.toggle('menu-open',open);};
}
document.addEventListener('keydown',event=>{if(event.key==='Escape'&&menu?.getAttribute('aria-expanded')==='true'){menu.setAttribute('aria-expanded','false');nav?.classList.remove('menu-open');menu.focus();}});
const year=document.getElementById('footer-year');if(year)year.textContent=new Date().getFullYear();
document.querySelectorAll('[data-business-email]').forEach(el=>{el.textContent=business.email;el.href=`mailto:${business.email}`;});
document.querySelectorAll('[data-business-address]').forEach(el=>el.textContent=business.address);
if(window.PevitaCommerce){
  document.querySelectorAll('[data-shopify-only]').forEach(el=>el.hidden=false);
  document.querySelectorAll('[data-contact-link]').forEach(el=>el.href=window.PevitaCommerce.contactUrl);
  document.querySelectorAll('[data-privacy-link]').forEach(el=>{if(window.PevitaCommerce.privacyUrl)el.href=window.PevitaCommerce.privacyUrl;});
  document.querySelectorAll('[data-cookie-link]').forEach(el=>el.addEventListener('click',event=>{event.preventDefault();const shopify=window.Shopify;if(shopify?.loadFeatures){shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>{if(error)return;window.privacyBanner?.showPreferences?.();});}else if(window.privacyBanner?.showPreferences)window.privacyBanner.showPreferences();}));
}
localisePolicyLinks();
function clarityCartEvent(name){
 try{
  if(window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()!==true)return false;
  window.clarity=window.clarity||function(){(window.clarity.q=window.clarity.q||[]).push(arguments);};
  window.clarity('event',name);return true;
 }catch{return false;}
}
const form=document.getElementById('native-cart-form');
if(form){
  let cartViewSent=false;
  const recordCartView=()=>{if(!cartViewSent)cartViewSent=clarityCartEvent('pevita_native_cart_viewed');};
  document.addEventListener('visitorConsentCollected',recordCartView);
  recordCartView();
  if(typeof window.Shopify?.customerPrivacy?.analyticsProcessingAllowed!=='function'){
    try{window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.1'}],error=>{if(!error)recordCartView();});}catch{}
  }
  const delivery=mountDelivery();
  let updating=false;
  form.addEventListener('submit',async event=>{
    event.preventDefault();
    const checkout=event.submitter?.name==='checkout';
    const terms=document.getElementById('cart-terms');if(terms)terms.required=checkout;
    const valid=form.reportValidity();if(terms)terms.required=true;
    if(updating||!valid)return;
    updating=true;
    const buttons=[...form.querySelectorAll('button')];buttons.forEach(button=>button.disabled=true);
    const status=document.getElementById('native-cart-status');status.hidden=false;status.textContent='Actualizando tu carrito…';
    try{
      const updates=Object.fromEntries([...form.querySelectorAll('input[name="updates[]"]')].map(input=>[input.dataset.lineKey,Number(input.value)]));
      await request('cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates,note:document.getElementById('cart-note').value,attributes:delivery.attributes()})});
      if(checkout){clarityCartEvent('pevita_checkout_redirect');location.assign(checkoutWithDiscount(localizedUrl('/checkout',getLanguage(),location.href,window.PevitaCommerce?.languages||[])||'/checkout'));}else location.reload();
    }catch(error){status.textContent=error.message;updating=false;buttons.forEach(button=>{if(button.name==='update')button.disabled=false;});}
  });
  form.querySelectorAll('input[name="updates[]"]').forEach(input=>input.addEventListener('input',()=>{
    delivery.invalidate();
    const checkout=form.querySelector('[name="checkout"]');if(checkout)checkout.disabled=true;
    document.getElementById('cart-update-hint').hidden=false;
  }));
}
